import { render } from "./ShareToSocialMedia.vue?vue&type=template&id=07d02ca9&scoped=true"
import script from "./ShareToSocialMedia.vue?vue&type=script&lang=js"
export * from "./ShareToSocialMedia.vue?vue&type=script&lang=js"

import "./ShareToSocialMedia.vue?vue&type=style&index=0&id=07d02ca9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d02ca9"]])

export default __exports__